export function generateBreadcrumbSchema (breadcrumbs) {
  const itemListElement = breadcrumbs.map((breadcrumb, index) => {
    let item

    if (breadcrumb.url) {
      item = breadcrumb.url.startsWith('/') ? `https://querobolsa.com.br${breadcrumb.url}` : breadcrumb.url
    }

    return {
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.text,
      item,
    }
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
    numberOfItems: itemListElement.length,
  }
}
